import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import BirthContainer from './container/BirthContainer';
import SearchContainer from './container/search/SearchContainer';
import BirthCertificateListingContainer from './container/records/container/BirthCertificateListingContainer';

function BirthTabContainer({ match, pathName, permissions }) {
  
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/civil-registry/birth-certificate"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                    '/civil-registry/birth-certificate/transactions'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Birth Certificate
                </Link>
              </li>
              {Acl(permissions, ['SEARCH BIRTH CERTIFICATE']) && (
                <li className="nav-item">
                  <Link
                    to="/civil-registry/birth-certificate/search"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                      '/civil-registry/birth-certificate/search'
                    ) > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Search
                  </Link>
                </li>
              )}
              {Acl(permissions, ['BIRTH CERTIFICATE RECORD MAINTENANCE']) && (
                <li className="nav-item">
                  <Link
                    to="/civil-registry/birth-certificate/records-maintenance"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                      '/civil-registry/birth-certificate/records-maintenance'
                    ) > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Record Maintenance
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          <Route
            path={`${match.path}/transactions`}
            component={BirthContainer}
          />
          <Route path={`${match.path}/search`} component={SearchContainer} />
          <Route
            path={`${match.path}/records-maintenance`}
            component={BirthCertificateListingContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

BirthTabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(BirthTabContainer);
